import { connect } from 'react-redux';
import DxgMenuDetailsUI from './DxgMenuDetailsUI';
import { IDxgMenuDetailsUIStateProps, IDxgMenuDetailsUIMenuProductsList } from './DxgMenuDetailsUI';

export const mapStateToProps = (state: any, props: any): IDxgMenuDetailsUIStateProps => {
    const menuProductsList: IDxgMenuDetailsUIMenuProductsList[] = [];
    const sentMenuProducts = props.selector.getSelectedProtectionList(state);

    if (sentMenuProducts) {
        sentMenuProducts.forEach((sentMenuProduct) => {
            if (sentMenuProduct.cardHeading) {
                const name = sentMenuProduct.cardHeading;
                const price = sentMenuProduct.totalPrice || '--';
                menuProductsList.push({ name, price });
            }
        });
    }

    return { menuProductsList };
};

const DxgMenuDetails = connect(mapStateToProps)(DxgMenuDetailsUI);

export default DxgMenuDetails;
